export var BrandPageModal;
(function(BrandPageModal) {
    BrandPageModal["CONTACT_MAKER"] = "CONTACT_MAKER";
    BrandPageModal["RESUME_INSIDER"] = "RESUME_INSIDER";
    BrandPageModal["STORY"] = "STORY";
    BrandPageModal["ZIPCODE_PROTECTED"] = "ZIPCODE_PROTECTED";
    BrandPageModal["RESTRICTED"] = "RESTRICTED";
    BrandPageModal["UPDATE_CART"] = "UPDATE_CART";
    BrandPageModal["SAMPLE_REQUEST"] = "SAMPLE_REQUEST";
    BrandPageModal["SHARE_CONTACT_INFO"] = "SHARE_CONTACT_INFO";
    BrandPageModal["REQUEST_EXCLUSIVITY"] = "REQUEST_EXCLUSIVITY";
})(BrandPageModal || (BrandPageModal = {}));
